import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
    collection,
    getDocs,
    query,
    where,
    doc,
    getDoc
} from "firebase/firestore";
import { auth, db } from "../firebase";
import Menu from "../panel/Menu";

import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography
} from "@mui/material";

function Dashboard() {
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000
    });

    const [propertyId, setPropertyId] = useState(null);

    const [depcount, setdepcount] = useState(0);
    const [prodcount, setprodcount] = useState(0);
    const [pocount, setpocount] = useState(0);
    const [reqcount, setreqcount] = useState(0);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                await fetchUserRole(user.uid);
            }
        });

        return () => unsubscribe();
    }, []);

    const fetchUserRole = async (uid) => {
        try {
            const docRef = doc(db, "authroles", uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const propId = docSnap.data().propertyId;
                setPropertyId(propId);
                fetchCounts(propId);
            }
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    };

    const fetchCounts = async (propId) => {
        try {
            const queries = [
                query(collection(db, "departments"), where("propertyId", "==", propId)),
                query(collection(db, "storeproducts"), where("propertyId", "==", propId)),
                query(
                    collection(db, "poregisters"),
                    where("propertyId", "==", propId),
                    where("type", "==", "Purchase Order")
                ),
                query(
                    collection(db, "poregisters"),
                    where("propertyId", "==", propId),
                    where("type", "==", "Requisitions")
                )
            ];

            const [
                depSnap,
                prodSnap,
                poSnap,
                reqSnap
            ] = await Promise.all(queries.map((q) => getDocs(q)));

            setdepcount(depSnap.size);
            setprodcount(prodSnap.size);
            setpocount(poSnap.size);
            setreqcount(reqSnap.size);
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    };

    const DashboardCard = ({ title, count, gradient }) => (
        <Grid item xs={12} sm={6} md={3}>
            <Card
                sx={{
                    background: gradient,
                    color: "#fff",
                    borderRadius: 3,
                    boxShadow: 5,
                    transition: "0.3s",
                    "&:hover": {
                        transform: "translateY(-5px)"
                    }
                }}
            >
                <CardContent>
                    <Typography variant="h4" fontWeight="bold">
                        {count}
                    </Typography>
                    <Typography variant="subtitle1">{title}</Typography>
                </CardContent>
            </Card>
        </Grid>
    );

    return (
        <Box className="content-wrapper" sx={{ display: "flex" }}>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 4,
                    backgroundColor: "#f4f6f9",
                    minHeight: "100vh"
                }}
            >
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    mb={4}
                >
                    Dashboard
                </Typography>

                <Grid container spacing={3}>
                    <DashboardCard
                        title="Departments"
                        count={depcount}
                        gradient="linear-gradient(45deg, #ec4899, #f472b6)"
                    />
                    <DashboardCard
                        title="Products"
                        count={prodcount}
                        gradient="linear-gradient(45deg, #f97316, #fb923c)"
                    />

                </Grid>
            </Box>
        </Box>
    );
}

export default Dashboard;